import classNames from 'classnames'

import FormattedDate from '../../common/components/FormattedDate.js'

import {showCartSyncModal} from '../Modals/CartSyncModal/cartSyncModalFunctions.js'
import {allCartsAreWebhookedSelector} from '../../data/carts.js'
import {
  areTasksRunningSelector,
  checkRunningTasks,
  mostRecentlyUpdatedTaskSelector,
} from '../../data/tasks.js'
import Icon from '../../common/icons/Icon.js'
import {useSelector} from '../../store.js'
import {useEffect} from 'react'

export default function SyncStatus() {
  const task = useSelector(mostRecentlyUpdatedTaskSelector)
  const areTasksRunning = useSelector(areTasksRunningSelector)
  const allCartsAreWebhooked = useSelector(allCartsAreWebhookedSelector)

  useEffect(() => {
    if (!task) {
      checkRunningTasks()
    }
  }, [])

  if (allCartsAreWebhooked) {
    return null
  }

  return (
    <div className="panel panel--dashboard padding-left-20 padding-right-20">
      <div className="clearfix margin-top-20 margin-bottom-15 align-center">
        {!task && (
          <p className="fs-01 lh-md margin-bottom-10">
            <em>Loading sync status...</em>
          </p>
        )}
        {task && (
          <div className="flex--justify-col">
            {!areTasksRunning && (
              <>
                <p className="fs-01 lh-md margin-bottom-0">
                  <strong>LATEST SYNC:</strong>
                </p>
                <p className="fs-01 lh-md margin-bottom-10">
                  <FormattedDate value={task.updated} format="lll" />
                </p>
              </>
            )}
            {areTasksRunning && (
              <p className="fs-01 lh-md margin-bottom-10">
                <em>Syncing with your sales channels...</em>
              </p>
            )}
          </div>
        )}
        <div className="margin-bottom-10">
          <button
            className={classNames(
              'btn btn--primary btn--primary-alt btn--x-md lh-sm ws-normal w-100 margin-bottom-0',
              {
                'btn--processing': areTasksRunning,
              },
            )}
            type="button"
            onClick={() => showCartSyncModal()}
          >
            <Icon
              name="sync"
              className="inline-block v-align-middle fs-01 op-75 margin-right-5"
            />
            <span className="inline-block v-align-middle">
              Sync Sales Channels
            </span>
          </button>
        </div>

        <div className="medium-7 columns flex--justify-col"></div>
      </div>
    </div>
  )
}
